// @flow
import React from "react"
import type { HOC, Component } from "recompose"
import withSubmit from "hoc/withSubmit"
import { Text } from "componentsStyled/Typography/Texts"
import ModalBody from "modals/_Body"
import ModalHeader from "modals/_Header"
import ModalContent from "modals/_Content"
import ModalControls from "modals/_Controls"
import { Wrap } from "componentsStyled/Layout/Wrap"
import Button from "components/Button"
import { ButtonsWrap } from "./styled"

const ConfirmModal = ({
  title,
  message,
  component,
  submit,
  close,
  loading,
}) => (
  <ModalBody close={close}>
    <ModalHeader close={close} title={title} />
    <ModalContent>
      <Wrap>{component ? component : <Text center>{message}</Text>}</Wrap>
    </ModalContent>
    <ModalControls>
      <ButtonsWrap>
        <Button onClick={close} secondary>
          Close
        </Button>
        <Button loading={loading} onClick={() => submit()}>
          Confirm
        </Button>
      </ButtonsWrap>
    </ModalControls>
  </ModalBody>
)

type Outter = {|
  close: Function,
  onConfirm: void => Promise<mixed>,
  title: string,
  message?: string,
  component?: Component,
|}

const enhancer: HOC<*, Outter> = withSubmit({
  submit: props => props.onConfirm,
  onSuccess: props => props.close,
  errorText: "Something went wrong!",
})

export default enhancer(ConfirmModal)



// WEBPACK FOOTER //
// ./src/modals/Confirm/index.js